class Animate2 {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.timelines = []
        this.run()
    }
    run() {
        // Initialize ScrollTrigger
        gsap.registerPlugin(ScrollTrigger);
        window.addEventListener('filter:change', () => {
            this.reinit()
        })
        this.reinit()
    }
    reinit() {
        if (window.matchMedia('(max-width: 500px)').matches) {
            return
        }

        document.querySelectorAll('[data-animate]').forEach((el) => {
            const link = el.querySelector('a')
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: link,
                    start: "top 80%",
                    end: "bottom 40%",
                    toggleActions: "restart none none reverse",
                    scrub: 1,
                },
            }).to(el, {
                yPercent: -20
            }, 0);
        });
    }
}

export default Animate2